import { apparels2Schemas } from './apparels/apparels-2/builder-schemas'
import { apparels3Schemas } from './apparels/apparels-3/builder-schemas'
import { apparels4Schemas } from './apparels/apparels-4/builder-schemas'
import { apparels5Schemas } from './apparels/apparels-5/builder-schemas'
import { footwear1Schemas } from './footwear/footwear-1/builder-schemas'
import { essentials1Schemas } from './essentials/essentials-1/builder-schemas'
import { essentials2Schemas } from './essentials/essentials-2/builder-schemas'
import { books1Schemas } from './books/books-1/builder-schemas'
import { gadgets1Schemas } from './gadgets/gadgets-1/builder-schemas'
import { computers1Schemas } from './computers/computers-1/builder-schemas'
import { furniture1Schemas } from './furniture/furniture-1/builder-schemas'
import { lightings1Schemas } from './lightings/lightings-1/builder-schemas'
import type { ComponentSchema } from '../schema-types'
import { toolsSchemas } from './shared/tools'
import type { ThemeFit } from '../tailor'
import { apparels2Fit } from './apparels/apparels-2/section-fit'
import { apparels3Fit } from './apparels/apparels-3/section-fit'
import { apparels4Fit } from './apparels/apparels-4/section-fit'
import { apparels5Fit } from './apparels/apparels-5/section-fit'
import { footwear1Fit } from './footwear/footwear-1/section-fit'
import { books1Fit } from './books/books-1/section-fit'
import { essentials1Fit } from './essentials/essentials-1/section-fit'
import { essentials2Fit } from './essentials/essentials-2/section-fit'
import { furniture1Fit } from './furniture/furniture-1/section-fit'
import { gadgets1Fit } from './gadgets/gadgets-1/section-fit'
import { computers1Fit } from './computers/computers-1/section-fit'
import { lightings1Fit } from './lightings/lightings-1/section-fit'

export interface ThemeSchemas {
  componentSchemas: Record<string, ComponentSchema>
  headerSchema: ComponentSchema
  footerSchema: ComponentSchema
  floatingButtonsSchema: ComponentSchema
  mobileNavSchema: ComponentSchema
}

/**
 * Theme-agnostic sections every theme offers next to its own (src/themes/shared/tools: offers page, EMI and power
 * supply calculators, PC Builder). Their storefront components are shared `Section.vue` files drawn with tokens only.
 */
const withTools = (schemas: ThemeSchemas): ThemeSchemas => ({
  ...schemas,
  componentSchemas: { ...schemas.componentSchemas, ...toolsSchemas },
})

export const THEME_SCHEMAS_REGISTRY: Record<string, ThemeSchemas> = {
  'essentials-1': withTools(essentials1Schemas),
  'essentials-2': withTools(essentials2Schemas),
  'books-1': withTools(books1Schemas),
  'gadgets-1': withTools(gadgets1Schemas),
  'computers-1': withTools(computers1Schemas),
  'apparels-2': withTools(apparels2Schemas),
  'lightings-1': withTools(lightings1Schemas),
  'apparels-3': withTools(apparels3Schemas),
  'apparels-4': withTools(apparels4Schemas),
  'apparels-5': withTools(apparels5Schemas),
  'footwear-1': withTools(footwear1Schemas),
  'furniture-1': withTools(furniture1Schemas),
}

/**
 * Each theme's section fits (already applied to its schemas above). Kept here so validation knows the fields a
 * theme hides on purpose; add a theme to both lists.
 */
export const THEME_FITS: Record<string, ThemeFit> = {
  'essentials-1': essentials1Fit,
  'essentials-2': essentials2Fit,
  'books-1': books1Fit,
  'gadgets-1': gadgets1Fit,
  'computers-1': computers1Fit,
  'apparels-2': apparels2Fit,
  'lightings-1': lightings1Fit,
  'apparels-3': apparels3Fit,
  'apparels-4': apparels4Fit,
  'apparels-5': apparels5Fit,
  'footwear-1': footwear1Fit,
  'furniture-1': furniture1Fit,
}

export const getThemeSchemas = (themeId: string): ThemeSchemas | null =>
  THEME_SCHEMAS_REGISTRY[themeId] ?? null
